'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
require('./_index.scss.js');

var CLASSNAME = 'varta-category-title';
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function CategoryTitle(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(className, CLASSNAME)
  }, children);
}
CategoryTitle.propTypes = {
  /** Child nodes */
  children: PropTypes.node,

  /** Additional class name */
  className: PropTypes.string
};

module.exports = CategoryTitle;
